module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0096.jpg?v=9baa833b";